import { TPoint } from '../points.model';

export const findCommonTags = (points: TPoint[]): string[] => {
  const [firstPoint, ...otherPoints] = points;

  if (!firstPoint) {
    return [];
  }

  return (firstPoint.tags ?? []).filter((tag) =>
    otherPoints.every((point) => (point.tags ?? []).includes(tag)),
  );
};
